import api from "..";
import type {
  IGetDownloadReceiptResponse,
  IGetReceiptRecordResponse,
} from "./type";

export const getLast7DayReceiptList = async (
  ms_token: string,
  car_plate: string,
  otp: string,
  phone: string
) => {
  const response = await api.post<IGetReceiptRecordResponse>(
    `/ace_parking_system/pay/getLast7timePayRecordByCarPlate`,
    {
      car_plate: car_plate,
      otp: otp,
      phone: phone,
    },
    {
      headers: {
        ms_token: ms_token,
      },
    }
  );

  return response.data;
};

export const downloadPayReceipts = async (
  ms_token: string,
  car_plate: string,
  pay_ids: string[]
) => {
  const response = await api.post<IGetDownloadReceiptResponse>(
    `/ace_parking_system/pay/downloadParkingPayRecordReceiptByCarPlate`,
    {
      car_plate: car_plate,
      pay_ids: pay_ids,
    },
    {
      headers: {
        ms_token: ms_token,
      },
    }
  );

  return response.data;
};
